import React, { useState } from "react";
import { StyledPeriodSelector } from "./style";

/**
 *
 * @param {Object} param
 * @param {boolean} param.monthMode - true일 경우 1개월, 3개월, 6개월만 노출
 * @returns
 */
export const PeriodSelector = ({ monthMode, setStartDate, setEndDate }) => {
  const [selectedRange, setSelectedRange] = useState();
  const today = new Date();

  const getAllDates = () => {
    setStartDate("2023-01-01");
    setEndDate(today);
    setSelectedRange(0);
  };
  const getYesterDay = () => {
    const yesterday = new Date(today);
    setStartDate(yesterday.setDate(yesterday.getDate() - 1));
    setEndDate(today);
    setSelectedRange(1);
  };
  const getToday = () => {
    setStartDate(today);
    setEndDate(today);
    setSelectedRange(2);
  };
  const getLastWeek = () => {
    const lastWeek = new Date(today);
    setStartDate(lastWeek.setDate(lastWeek.getDate() - 6));
    setEndDate(today);
    setSelectedRange(3);
  };
  const getLastMonth = () => {
    const lastMonth = new Date(
      today.getFullYear(),
      today.getMonth() - 1,
      today.getDate()
    );
    setStartDate(lastMonth);
    setEndDate(today);
    setSelectedRange(4);
  };
  const getLastThreeMonths = () => {
    const lastThreeMonths = new Date(
      today.getFullYear(),
      today.getMonth() - 3,
      today.getDate()
    );
    setStartDate(lastThreeMonths);
    setEndDate(today);
    setSelectedRange(5);
  };
  const getLastSixMonths = () => {
    const lastSixMonths = new Date(
      today.getFullYear(),
      today.getMonth() - 6,
      today.getDate()
    );
    setStartDate(lastSixMonths);
    setEndDate(today);
    setSelectedRange(7);
  };
  const getLastYear = () => {
    const lastYear = new Date(
      today.getFullYear() - 1,
      today.getMonth(),
      today.getDate()
    );
    setStartDate(lastYear);
    setEndDate(today);
    setSelectedRange(6);
  };

  return (
    <StyledPeriodSelector>
      <div className="period-selector">
        {!monthMode && (
          <React.Fragment>
            <button
              className={selectedRange === 0 ? "active" : ""}
              onClick={() => getAllDates()}
            >
              전체
            </button>
            <button
              className={selectedRange === 1 ? "active" : ""}
              onClick={() => getYesterDay()}
            >
              어제
            </button>
            <button
              className={selectedRange === 2 ? "active" : ""}
              onClick={() => getToday()}
            >
              오늘
            </button>
            <button
              className={selectedRange === 3 ? "active" : ""}
              onClick={() => getLastWeek()}
            >
              1주일
            </button>
          </React.Fragment>
        )}
        <button
          className={selectedRange === 4 ? "active" : ""}
          onClick={() => getLastMonth()}
        >
          1개월
        </button>
        <button
          className={selectedRange === 5 ? "active" : ""}
          onClick={() => getLastThreeMonths()}
        >
          3개월
        </button>
        {monthMode && (
          <button
            className={selectedRange === 7 ? "active" : ""}
            onClick={() => getLastSixMonths()}
          >
            6개월
          </button>
        )}
        {!monthMode && (
          <button
            className={selectedRange === 6 ? "active" : ""}
            onClick={() => getLastYear()}
          >
            1년
          </button>
        )}
      </div>
    </StyledPeriodSelector>
  );
};
